// Lostpod: Umschalter (z. B. AirPods / Beats) in Held-Abschnitt und Handy-Menü
document.addEventListener('click', function (e) {
  var knopf = e.target.closest('[data-lp-tab]')
  if (!knopf) return
  var gruppe = knopf.closest('[data-lp-tabs]')
  if (!gruppe) return
  var ziel = knopf.getAttribute('data-lp-tab')
  gruppe.querySelectorAll('[data-lp-tab]').forEach(function (k) { k.setAttribute('aria-selected', k === knopf ? 'true' : 'false') })
  gruppe.querySelectorAll('[data-lp-feld]').forEach(function (f) { f.hidden = f.getAttribute('data-lp-feld') !== ziel })
})

// Lostpod: zuletzt angesehenes Produkt für die Startseite merken.
// Nur mit Einwilligung „Präferenzen“ im Cookie-Banner, bleibt im Browser (localStorage), wird nirgends hingeschickt.
var LP_ZULETZT = 'lp_zuletzt'
function lpEinwilligung(fertig) {
  function pruefen() { try { fertig(!!window.Shopify.customerPrivacy.preferencesProcessingAllowed()) } catch (e) { fertig(false) } }
  if (window.Shopify && window.Shopify.customerPrivacy) return pruefen()
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) { if (fehler) fertig(false); else pruefen() })
  } else fertig(false)
}
function lpZuletztMerken(erlaubt) {
  try {
    if (!erlaubt) return localStorage.removeItem(LP_ZULETZT)
    var daten = document.getElementById('LpZuletztDaten')
    if (!daten) return
    var neu = JSON.parse(daten.textContent)
    var alt = JSON.parse(localStorage.getItem(LP_ZULETZT) || 'null')
    if (alt && alt.id === neu.id) { neu.n = Object.assign(alt.n || {}, neu.n); neu.u = Object.assign(alt.u || {}, neu.u) }
    localStorage.setItem(LP_ZULETZT, JSON.stringify(neu))
  } catch (e) {}
}
// Einwilligung geändert: merken oder löschen
document.addEventListener('visitorConsentCollected', function (e) { lpZuletztMerken(!!(e.detail && e.detail.preferencesAllowed)) })
// Produktseite: merken, wenn erlaubt; Startseite: gemerkten Eintrag löschen, falls die Einwilligung inzwischen fehlt
if (document.getElementById('LpZuletztDaten')) lpEinwilligung(lpZuletztMerken)
else if (document.querySelector('.lp-held__bild--zuletzt')) lpEinwilligung(function (erlaubt) { if (!erlaubt) lpZuletztMerken(false) })

// Lostpod: Hinweis „Lieber so einkaufen?“ unter der Länder- und Sprachauswahl.
// Fragt Shopify nach dem Standort (IP) und der Browsersprache. Passt beides schon zur Auswahl, passiert nichts.
// Umgestellt wird nur per Klick, nie automatisch (EU-Geoblocking-Verordnung, Google). Geschlossen bleibt er für diesen Besuch zu.
;(function () {
  var karte = document.getElementById('LpHinweis'), daten = document.getElementById('LpHinweisDaten')
  if (!karte || !daten || /bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return
  try { if (sessionStorage.getItem('lp_hinweis') === 'zu') return } catch (e) {}
  function merken () { try { sessionStorage.setItem('lp_hinweis', 'zu') } catch (e) {} }
  var d = JSON.parse(daten.textContent), land = null, sprache = null
  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=true')
    .then(function (r) { return r.ok ? r.json() : null })
    .then(function (r) {
      if (!r) return null
      var erkannt = r.detected_values && r.detected_values.country && r.detected_values.country.handle
      var vorschlag = (r.suggestions || []).filter(function (s) { return s.parts && s.parts.language })[0]
      var browser = vorschlag && vorschlag.parts.language.handle
      if (erkannt && erkannt !== d.land && d.laender.indexOf(erkannt) >= 0) land = erkannt
      if (browser && browser !== d.sprache && d.start[browser]) sprache = browser
      if (!land && !sprache) return null
      // Texte in der Sprache, die vorgeschlagen wird (sonst in der jetzigen)
      var start = d.start[sprache || d.sprache]
      return fetch(start + (start.indexOf('?') < 0 ? '?' : '&') + 'section_id=lostpod-hinweis').then(function (r) { return r.ok ? r.text() : null })
    })
    .then(function (html) {
      if (!html) return
      var t = new DOMParser().parseFromString(html, 'text/html').getElementById('LpHinweisTexte')
      if (!t) return
      t = JSON.parse(t.textContent)
      var zielLand = land || d.land, zielSprache = sprache || d.sprache, l = t.laender[zielLand]
      if (!l) return
      karte.lang = zielSprache
      karte.querySelector('.lp-hinweis__frage').textContent = t.frage
      karte.querySelector('.lp-hinweis__flagge').src = l.f
      karte.querySelector('.lp-hinweis__land').textContent = l.n
      karte.querySelector('.lp-hinweis__waehrung').textContent = l.w
      karte.querySelector('.lp-hinweis__sprache').textContent = t.sprachen[zielSprache] || ''
      karte.querySelector('.lp-hinweis__los').textContent = t.umstellen
      var zu = karte.querySelector('[data-lp-hinweis-zu]')
      zu.setAttribute('aria-label', t.schliessen); zu.title = t.schliessen
      var form = karte.querySelector('form')
      form.elements.country_code.value = zielLand
      form.elements.language_code.value = zielSprache
      form.addEventListener('submit', merken)
      zu.addEventListener('click', function () { karte.hidden = true; merken() })
      karte.hidden = false
    })
    .catch(function () {})
})()

// Lostpod: Ratgeber – Inhaltsverzeichnis aus den Zwischenüberschriften und aufklappbare Fragen (je h3 mit Antwort).
// Der Text bleibt für Suchmaschinen unverändert lesbar; ohne JavaScript erscheint er einfach ohne diese Hilfen.
;(function () {
  var text = document.querySelector('[data-lp-ratgeber]')
  if (!text) return
  // Übersicht: Satzzeichen nach dem Link weg (er steht als Kartentitel darüber) und Symbol aus dem Menü davor
  if (text.closest('.lp-rg--uebersicht')) {
    text.querySelectorAll('li > a:first-child').forEach(function (a) {
      var rest = a.nextSibling
      if (rest && rest.nodeType === 3) rest.textContent = rest.textContent.replace(/^\s*[:\-–—]\s*/, '')
      var t = document.querySelector('template[data-lp-symbol-fuer="' + a.getAttribute('href') + '"]')
      if (t) { a.parentNode.insertBefore(t.content.cloneNode(true), a.parentNode.firstChild); a.parentNode.classList.add('lp-mit-symbol') }
    })
  }
  // Fragen: jede h3 mit allem bis zur nächsten h2/h3 in ein <details>
  text.querySelectorAll('h3').forEach(function (h3) {
    var d = document.createElement('details'), s = document.createElement('summary')
    d.className = 'lp-rg-frage'
    h3.parentNode.insertBefore(d, h3)
    s.appendChild(h3)
    d.appendChild(s)
    while (d.nextElementSibling && !/^H[23]$/.test(d.nextElementSibling.tagName)) d.appendChild(d.nextElementSibling)
  })
  // Inhaltsverzeichnis ab drei Zwischenüberschriften
  var inhalt = document.querySelector('[data-lp-inhalt]'), h2 = text.querySelectorAll('h2')
  if (!inhalt || h2.length < 3) return
  var liste = inhalt.querySelector('ol'), links = []
  h2.forEach(function (h, i) {
    if (!h.id) h.id = 'abschnitt-' + (i + 1)
    var li = document.createElement('li'), a = document.createElement('a')
    a.href = '#' + h.id
    a.textContent = h.textContent.replace(/^\d+\.\s*/, '')
    li.appendChild(a); liste.appendChild(li); links.push(a)
  })
  inhalt.hidden = false
  if (window.matchMedia('(min-width: 990px)').matches) inhalt.open = true
  inhalt.querySelector('summary').addEventListener('click', function (e) { if (window.matchMedia('(min-width: 990px)').matches) e.preventDefault() })
  if (!('IntersectionObserver' in window)) return
  var beob = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      if (!e.isIntersecting) return
      links.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + e.target.id ? 'true' : 'false') })
    })
  }, { rootMargin: '0px 0px -70% 0px' })
  h2.forEach(function (h) { beob.observe(h) })
})()
